module.exports = __webpack_public_path__ + "static/media/login-portrait-footer.4f5ffb6a.svg";